module.exports = __webpack_public_path__ + "img/learn-power-logo01.e9e587c1.png";